import React, { useEffect, useState } from "react";
import { cellWidth } from "../../../../core/methods/tableCellWidth";
import {
  parseDate,
  parseNumber,
  parseTiming,
  safeLocaleCompare,
} from "../../../../core/methods/sorterMethods";
import { ColumnsType } from "antd/es/table";
import FiltersTrackCase, {
  FiltersSelectType,
  initialFilterSelect,
  SearchFormDataType,
} from "../FiltersTrackCase";
import Datatable from "../../../../core/common/dataTable";
import TimelineModal from "../TimelineModal";
import { Space } from "antd";
import { DownloadOutlined, EyeOutlined, SendOutlined } from "@ant-design/icons";
import {
  dummyData_finalReport,
  timelineData_invite,
} from "../../../../core/data/js/dummy-data";
import { formattedDate, formattedDateDDMMMMYYYY } from "../../../../core/methods/formattedDate";
import useApi from "../../../../core/customhook/useApi";
import webservice_url from "../../../../core/webservice/Webservice_url";

const colorStyle: Record<string, string> = {
  orange: "text-primary",
  green: "text-success",
  red: "text-danger"
};

const dummyData_downloadReport = [
  {
    key: "1",
    caseId: "374500",
    completionDate: "",
    reportType: "INTERIM",
    reportStatus: "GREEN",
    reportDispatch: "09-05-2026",
  },
  {
    key: "2",
    caseId: "374500",
    completionDate: "",
    reportType: "FINAL",
    reportStatus: "Orange",
    reportDispatch: "16-05-2026",
  },
];

const CompletedReports = () => {
  const [itemList, setItemList] = useState([]);
  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [filterData, setFilterData] = useState<FiltersSelectType>(initialFilterSelect);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });
  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [showDownloadReportModal, setShowDownloadReportModal] =
    useState<boolean>(false);

  // handleClose download Report
  const handleCloseReportModal = () => setShowDownloadReportModal(false);

  // ---- columns ----
  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      key: "sno",
      align: "center",
      render: (_: any, _record: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Applicant Name",
      dataIndex: "applicant_name",
      key: "applicant_name",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_name")
    },
    {
      title: "Case ID",
      dataIndex: "case_id",
      key: "case_id",
      onCell: () => cellWidth(190),
      sorter: (a: any, b: any) => parseNumber(a.case_id) - parseNumber(b.case_id),
    },
    {
      title: "Email ID",
      dataIndex: "applicant_email",
      key: "applicant_email",
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_email")
    },
    {
      title: "SLA Due Date",
      dataIndex: "due_date",
      key: "due_date",
      onCell: () => cellWidth(190),
      render: (text: string) => {
        const date = formattedDate(text) ?? "-";
        return <span>{date}</span>
      },
      sorter: (a: any, b: any) =>
        parseDate(a.due_date).getTime() - parseDate(b.due_date).getTime(),
    },
    {
      title: "Completion Date",
      dataIndex: "completionDate",
      key: "completionDate",
      onCell: () => cellWidth(130),
      render: (text: string) => {
        const date = formattedDate(text) ?? "-";
        // const date = formattedDateDDMMMMYYYY(text) ?? "-";
        return <span>{date}</span>
      },
      sorter: (a: any, b: any) =>
        parseDate(a.completionDate).getTime() -
        parseDate(b.completionDate).getTime(),
    },
    {
      title: "Download Report",
      dataIndex: "",
      key: "",
      render: () => (
        <div
          className="text-center"
          onClick={() => setShowDownloadReportModal(true)}
        >
          <i className="ti ti-download text-info"></i>
        </div>
      ),
    },
    {
      title: "Color",
      dataIndex: "colour",
      key: "colour",
      onCell: () => cellWidth(190),
      render: (text: string) => (
        <div className={`${colorStyle[text?.toLowerCase()]}`}>{text}</div>
      ),
      sorter: (a, b) => safeLocaleCompare(a, b, "colour"),
    },
    {
      title: "Total Checks",
      dataIndex: "total_checks",
      key: "total_checks",
      align: "center",
      sorter: (a: any, b: any) =>
        parseNumber(a.total_checks) - parseNumber(b.total_checks),
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
      align: "center",
      sorter: (a: any, b: any) =>
        parseNumber(a.completed) - parseNumber(b.completed),
    },
    {
      title: "Stopped Checks",
      dataIndex: "stopped",
      key: "stopChecks",
      align: "center",
      sorter: (a: any, b: any) =>
        parseNumber(a.stopChecks) - parseNumber(b.stopChecks),
    },
    // {
    //   title: "Insuff Expire",
    //   dataIndex: "insufficiency_expired",
    //   key: "insuffExpire",
    //   align: "center",
    //   sorter: (a: any, b: any) =>
    //     parseNumber(a.insuffExpire) - parseNumber(b.insuffExpire),
    // },
    {
      title: "Hiring Status",
      dataIndex: "hiringStatus",
      key: "hiringStatus",
      onCell: () => cellWidth(150),
      render: (text: string) => {
        return <span className={`badge bg-soft-secondary `}>{text}</span>
      },
      sorter: (a, b) => safeLocaleCompare(a, b, "hiringStatus")
    },
    // {
    //   title: "Report Action",
    //   key: "",
    //   onCell: () => cellWidth(180),
    //   render: () => (
    //     <div className="dropdown">
    //       <button
    //         type="button"
    //         className="btn btn-xs dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //         style={{ width: "160px" }}
    //       >
    //         -- select --
    //       </button>
    //       <ul className="dropdown-menu ">
    //         <li>
    //           <button type="button" className="dropdown-item">
    //             Hiring Approval/Notice
    //           </button>
    //         </li>
    //         <li>
    //           <button type="button" className="dropdown-item">
    //             Recheck
    //           </button>
    //         </li>
    //       </ul>
    //     </div>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      onCell: () => cellWidth(190),
      render: (text: string) => <span className="small">{text}</span>,
      sorter: (a, b) => safeLocaleCompare(a, b, "status")
    },
    {
      title: "Processing Time",
      dataIndex: "processingTime",
      key: "processingTime",
      align: "center",
      sorter: (a: any, b: any) =>
        parseTiming(a.processingTime) - parseTiming(b.processingTime),
    },
    // {
    //   title: "View Log",
    //   key: "viewLog",
    //   onCell: () => cellWidth(100),
    //   render: () => (
    //     <div
    //       className="text-center text-dark"
    //       style={{ cursor: "pointer" }}
    //       onClick={() => setShowTimeline(true)}
    //     >
    //       <i className="ti ti-eye "></i>
    //     </div>
    //   ),
    // },
  ];

  //   columns report
  const columns_report: ColumnsType<any> = [
    {
      title: "Case Id",
      dataIndex: "caseId",
      key: "caseId",
      onCell: () => cellWidth(100),
    },
    {
      title: "Recheck Report Completion Date",
      dataIndex: "completionDate",
      key: "completionDate",
      // onCell: () => cellWidth(200),
    },
    {
      title: "Report Type",
      dataIndex: "reportType",
      key: "reportType",
      onCell: () => cellWidth(130),
    },
    {
      title: "Report Status",
      dataIndex: "reportStatus",
      key: "reportStatus",
      onCell: () => cellWidth(130),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Report Dispatch",
      dataIndex: "reportDispatch",
      key: "reportDispatch",
      onCell: () => cellWidth(160),
    },
    {
      title: "Report Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <button type="button" className="btn btn-primary py-1 px-2">
            <SendOutlined />
          </button>
          <button type="button" className="btn btn-primary py-1 px-2">
            <EyeOutlined />
          </button>
          <button type="button" className="btn btn-primary py-1 px-2">
            <DownloadOutlined />
          </button>
        </Space>
      ),
    },
  ];

  const { callApi: handlesSearch, data: dataList, loading: searchLoading } = useApi(webservice_url.search_live_case_progress, {
    method: "POST",
    autoCall: false
  })

  const handleTableChange = async (pagination: any) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }))
  };

  const fetchData = async (
    page = pagination.current,
    pageSize = pagination.pageSize
  ) => {

    const payload = {
      status: "",
      org_ids:
        filterData?.organization ||
        null,
      project_ids:
        filterData?.project ||
        null,
      program_ids:
        filterData?.program ||
        null,
      department_ids:
        filterData?.departments ||
        null,
      page,
      limit: pageSize,
    };

    try {
      const response = await handlesSearch(payload);

      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: response?.data?.total || 0,
      }));
    } catch (error) {
      console.error("API Failed", error);
    }
  };

  useEffect(() => {
    if (dataList?.data?.rows) {
      setItemList(dataList.data.rows);
    }
  }, [dataList]);

  useEffect(() => {
    fetchData(1, pagination.pageSize);
  }, [searchTrigger]);

  return (
    <>
      {/* filters */}
      <FiltersTrackCase
        filterData={filterData}
        searchFilter={searchFilter}
        setFilterData={setFilterData}
        setSearchFilter={setSearchFilter}
        onSearch={() => setSearchTrigger(prev => prev + 1)}
      />
      {/* Table  */}
      <div className="card mt-3">
        <Datatable
          dataSource={itemList}
          columns={columns}
          rowKey="case_id"
          Selection={false}
          pagination={pagination}
          handleTableChange={handleTableChange}
        />
      </div>

      {/* Download Report Modal */}
      {showDownloadReportModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={handleCloseReportModal}
          />
          <div
            className="modal fade show"
            style={{ display: "block" }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div
                className="modal-content mx-auto overflow-hidden"
                style={{ maxHeight: 600, maxWidth: 950 }}
              // style={{ maxHeight: 550, maxWidth: 800 }}
              >
                <div className="modal-header">
                  <h3 className="fw-bold ">Report</h3>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    onClick={handleCloseReportModal}
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <div className="modal-body px-2 px-md-4 pb-3 pt-0 pt-md-3 overflow-y-auto">
                  <Datatable
                    dataSource={dummyData_downloadReport}
                    columns={columns_report}
                    Selection={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Timeline Modal */}
      {showTimeline && (
        <TimelineModal
          timelineData={timelineData_invite}
          onClose={() => setShowTimeline(false)}
        />
      )}
    </>
  );
};

export default CompletedReports;
